import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as Yup from 'yup';
import { FormPage } from '../../../components/FormPage';
import { FormSection } from '../../../components/FormSection';
import { Select, TextField } from 'mui-rff';
import { MenuItem } from '@material-ui/core';

export function WebhookFormView({
    app,
    webhook,
    loading,
    onSubmit,
    deleting,
    onDelete,
    onCancel,
}: any) {
    if (app === undefined || webhook === undefined) {
        return <CircularProgress />;
    }

    const breadcrumbs = [
        { label: 'Apps', link: '/extranet/apps' },
        { label: 'Dashboard', link: '/extranet/apps/' + app.id + '/dashboard' },
    ];

    const validationSchema = Yup.object().shape({
        topic: Yup.string().required('You must select topic'),
        url: Yup.string()
            .matches(
                /^(?:([a-z0-9+.-]+):\/\/)(?:\S+(?::\S*)?@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/,
                { excludeEmptyString: true, message: 'URL must be valid' }
            )
            .max(255, 'Max 255 chars'),
    });

    // TODO can we not get this from the generated typescript?
    const topics = [
        'APP_UNINSTALL',
        'BOOKINGS_CREATE',
        'BOOKINGS_UPDATE',
        'BOOKINGS_CANCEL',
        'BOOKINGS_PAYMENT',
        'BOOKINGS_REFUND',
        'EXPERIENCES_CREATE',
        'EXPERIENCES_UPDATE',
        'EXPERIENCES_AVAILABILITY_UPDATE',
    ];

    // @ts-ignore
    return (
        <FormPage
            title={webhook.id ? 'Edit Webhook' : 'Create Webhook'}
            loading={loading}
            initialValues={webhook}
            onSubmit={onSubmit}
            onCancel={onCancel}
            onDelete={onDelete}
            deleting={deleting}
            breadcrumbs={breadcrumbs}
            validationSchema={validationSchema}
            render={() => (
                <React.Fragment>
                    <FormSection title="Webhook Details">
                        <Select
                            name="topic"
                            label="Select a topic"
                            formControlProps={{ margin: 'normal' }}
                            required={true}
                        >
                            {topics.map((t, key) => (
                                <MenuItem key={key} value={t}>
                                    {t}
                                </MenuItem>
                            ))}
                        </Select>

                        <TextField
                            name="url"
                            fullWidth
                            label="URL"
                            helperText="This is the URL you want us to POST to when an event is published to the selected topic."
                            margin="normal"
                            required
                        />
                    </FormSection>
                </React.Fragment>
            )}
        />
    );
}
